document.addEventListener("turbolinks:load", function () {
  if($('animal-form')) {
    previouslyCastratedSetup();
    animalAge();
  }
})

// note: maybe this logic could be extracted to a class specialized on set this kind of interaction.
// Config previously castrated iteractios.
function previouslyCastratedSetup() {
  $('#vet_animal_previously_castrated_true').on('click', () => {
    $('#div-castration-period').removeAttr('hidden')
  })

  $('#vet_animal_previously_castrated_false').on('click', () => {
    $('#div-castration-period').attr('hidden', 'true')
  })
}

// Add interaction used to render one type of animal age input
function animalAge() {
  $('#animal-birth-date').on('click', event => {
    event.preventDefault();
    $('#vet_animal_birth_date').removeAttr('hidden')
    $('#vet_animal_age').attr('hidden', 'true')
  })

  $('#animal-age').on('click', event => {
    event.preventDefault();
    $('#vet_animal_age').removeAttr('hidden')
    $('#vet_animal_birth_date').attr('hidden', 'true')
  })
}
